// Typelizer digest b90280cb47936026b90ec31151a8046a
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../runtime'
import { buildUrl } from '../runtime'

export default {
  /** GET /account/sign_in */
  new: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/account/sign_in', {}, options),
    method: 'get',
  }),

  /** POST /account/sign_in */
  create: (options?: RouteOptions): RouteDefinition<'post'> => ({
    url: buildUrl('/account/sign_in', {}, options),
    method: 'post',
  }),

  /** DELETE /account/sign_out */
  destroy: (options?: RouteOptions): RouteDefinition<'delete'> => ({
    url: buildUrl('/account/sign_out', {}, options),
    method: 'delete',
  }),
}
